module.exports = __webpack_public_path__ + "img/skip-backward.3ba18c0f.svg";